import type { JSX } from 'react';

import type { ErrorHandlerProps } from 'src/app/pages/about/team/pageContext';

export function TeamErrorHandler({ context: { error } }: ErrorHandlerProps): JSX.Element {
	throw new Error(`Failed to retrieve data for About/Team page (error: ${error})`);
}
